import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Utils
import useRequest from "../../utils/useRequest";

// Components
import PageWrapper from "../../components/PageWrapper";
import Loader from "../../components/Loader";
import PaperOrderList from "./PaperOrderList";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/toDate";
import PaperInvoiceList from "./PaperInvoiceList";
import SectionDivider from "../../components/SectionDivider";

export default function PaperInvoicePage() {
  // HOOKS
  const { id } = useParams();
  const { t } = useTranslation("general");

  // STATES
  const [fabricOrderItems, setFabricOrderItems] = useState([]);
  const [orderStatus, setOrderStatus] = useState("PENDING");
  const [customerData, setCustomerData] = useState({
    customerName: "",
    customerPhone: null,
    customerAddress: "",
  });

  const [invoiceDetails, setInvoiceDetails] = useState({
    invoiceNumber: null,
    invoiceDate: null,
  });

  // ENDPOINTS
  const { loading, error, data, refetch } = useRequest(
    `/getOneFabricSellInvoice/${id}`,
    "GET",
    null,
    {},
    true
  );

  useEffect(() => {
    if (data) {
      setFabricOrderItems(data);
      setOrderStatus(data?.status);
      setCustomerData(() => {
        return {
          customerName: data?.data.customer?.name,
          customerPhone: data?.data.customer?.phoneNumber,
          customerAddress: data?.data.customer?.address,
        };
      });

      setInvoiceDetails(() => {
        return {
          invoiceNumber: data?.data.id,
          invoiceDate: data?.data.date,
        };
      });
    }
  }, [data]);

  return (
    <PageWrapper withBackButton>
      <h1 className="t-headline-1 u-margin--top_700">{t("orderInfo")}</h1>

      <section className="o-column-row-switcher o-row--horizontal-align_space-between u-margin--top_100">
        {/* Column 1 */}
        <div className="o-column o-column--gap-size_300 u-padding--top_100">
          <div className="o-row o-row--gap-size_300">
            <span className="t-bold_bold u-min-width-specific_100">
              {t("customerName")}:
            </span>{" "}
            <span>{customerData?.customerName}</span>
          </div>

          <div className="o-row o-row--gap-size_300">
            <span className="t-bold_bold u-min-width-specific_100">
              {t("phoneNumber")}:
            </span>{" "}
            <span>{customerData?.customerPhone}</span>
          </div>

          <div className="o-row o-row--gap-size_300">
            <span className="t-bold_bold u-min-width-specific_100">
              {t("address")}:
            </span>{" "}
            <span>{customerData?.customerAddress}</span>
          </div>
        </div>

        {/* Column 2 */}
        <div className="o-column o-column--gap-size_300 u-padding--top_600">
          <div className="o-row o-row--gap-size_300">
            <span className="t-bold_bold u-min-width-specific_100">
              {t("invoiceNumber")}:
            </span>{" "}
            <span>{invoiceDetails?.invoiceNumber}</span>
          </div>

          <div className="o-row o-row--gap-size_300">
            <span className="t-bold_bold u-min-width-specific_100">
              {t("Date")}:
            </span>{" "}
            <span>{formatDate(invoiceDetails?.invoiceDate)}</span>
          </div>
        </div>
      </section>

      <div className="u-margin--top_700">
        <SectionDivider title={t("categories")} />
      </div>

      <div className="u-margin--top_500 u-margin--bottom_500">
        {loading ? (
          <Loader />
        ) : (
          <PaperInvoiceList
            data={fabricOrderItems}
            setData={setFabricOrderItems}
            orderStatus={orderStatus}
          />
        )}
      </div>
    </PageWrapper>
  );
}
